import type { User } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { UserMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const UserMention = Mention.extend<MentionOptions<User>>({
	name: "UserMention",
	atom: true,
	addAttributes() {
		return {
			id: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "user-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["user-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(UserMentionComponent)
	},
}).configure({
	suggestion,
})
